import { Link } from 'react-router-dom';

export default function ArticleFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100 py-10">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-3">Artykuły</h4>
            <div className="flex flex-col gap-2">
              <Link to="/artykul/kakobuy-spreadsheet-kompletny-przewodnik-2026" className="text-xs text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Kompletny przewodnik Kakobuy
              </Link>
              <Link to="/artykul/jak-korzystac-z-kakobuy-spreadsheet" className="text-xs text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Poradnik krok po kroku
              </Link>
              <Link to="/artykul/kakobuy-spreadsheet-porownanie-arkuszy-2026" className="text-xs text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Porównanie arkuszy 2026
              </Link>
            </div>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-3">Linki</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-xs text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Strona Główna
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Kakobuy Sheet
              </a>
            </div>
          </div>
        </div>
        <div className="pt-6 border-t border-secondary-700 text-center">
          <p className="text-xs text-secondary-400">
            &copy; 2026 Kakobuy Finds. Wszelkie prawa zastrzeżone.
          </p>
        </div>
      </div>
    </footer>
  );
}